// import { useState } from "react";
import { motion } from "framer-motion";
import { useState } from "react";
import React from 'react';
const ListSkills = () => {

    const skills = [
        {
            category:"Programming Languages & Markup",type:[
                {title:"HTML",level:"5",icon:"./img/icon/html-5.png"},
                {title:"CSS",level:"4",icon:"./img/icon/css.png"},
                {title:"Javascript",level:"4",icon:"./img/icon/js.png"},
                {title:"PHP",level:"4",icon:"./img/icon/php.png"},
            ], delay: 0.1
        },
        {
            category:"Libraries",type:[
                {title:"jQuery",level:"4",icon:"./img/icon/jquery.png"},
                {title:"React.js",level:"4",icon:"./img/icon/react.png"},
            ], delay: 0.3
        },
        {
            category:"Framework",type:[
                {title:"Next.js",level:"3.5",icon:"./img/icon/nextjs.png"},
                {title:"Laravel",level:"4.5",icon:"./img/icon/laravel.png"},
                {title:"CodeIgniter",level:"4.5",icon:"./img/icon/code-igniter.png"},
            ], delay: 0.5
        },
        {
            category:"Database Management Systems",type:[
                {title:"MariaDB",level:"4.5",icon:"./img/icon/mariadb.png"},
                {title:"PostgreSQL",level:"4.5",icon:"./img/icon/postgre.png"},
                {title:"SQL Server",level:"4.5",icon:"./img/icon/sql-server.png"},
            ], delay: 0.7
        },
        {
            category:"Operating System",type:[
                {title:"Windows",level:"4.5",icon:"./img/icon/windows.png"},
                {title:"Ubuntu",level:"4.5",icon:"./img/icon/ubuntu.png"},
            ], delay: 0.7
        },
        {
            category:"Server and Deployment",type:[
                {title:"Apache2",level:"4.5",icon:"./img/icon/apache2.png"},
                {title:"Nginx",level:"4.5",icon:"./img/icon/nginx.png"},
                {title:"Virtual Host Configuration",level:"4.5",icon:"./img/icon/virtual-host.png"},
                {title:"SSL Setup",level:"4.5",icon:"./img/icon/ssl.png"},
            ], delay: 0.7
        },
    ];
    const [activeIndex, setActiveIndex] = useState<number | null>(null);
    const toggleShowMore = (index: number) => {
        // setShowMore((prev) => ({
        // ...prev,
        // [index]: !prev[index],
        // }));
        setActiveIndex(prev => (prev === index ? null : index));
    };

     return(
        <div className="flex md:flex-row sm:flex-col flex-col gap-6 md:w-full">
            <div className="w-full md:w-1/2 sm:w-full order-2 md:order-1">
                {skills.map((item, index) => (  
                    <React.Fragment key={index}>
                        <motion.div 
                        initial={{ opacity: 0, y: 50 }} 
                        whileInView={{ opacity: 1, y: 0 }} // animasi saat masuk viewport
                        // animate={{ opacity: 1, y: 0 }} 
                        transition={{ duration: 0.8, ease: "easeOut", delay: item.delay }}  
                        viewport={{ once: false, amount: 0.2 }} // jalan berulang, trigger saat 20% terlihat
                        className="">
                        <div className="flex justify-between items-center md:p-2">
                            <div className={`p-5 rounded-xl w-[300px] sm:w-[300px] md:w-[700px] transition-colors duration-700 ease-in-out ${
                                    activeIndex === index
                                    ? 'bg-[#0f8bd4]' // warna saat aktif (Read More)
                                    : 'bg-white/30 bg-gradient-to-r from-[#0d3270] to-[#5381b8]'
                                }`}>
                                <h1 className={`text-xl  font-montserrat text-white ${activeIndex === index ? 'font-bold text-[#e4eaf5]':'text-[#ffffff]' }`}>{item.category}</h1>
                                {/* <div className="h-2"></div> */}
                                <div className="space-y-2">
                                        <button onClick={() => toggleShowMore(index)} className="mt-3 text-black-600 text-sm text-white font-semibold hover:underline">
                                            {activeIndex === index ? "Read less ↑" : "Read more →"}
                                        </button>
                                </div>
                            </div>
                        </div>
                        </motion.div>
                        <div className="h-2"></div>
                    </React.Fragment>
                    
                ))}
            </div>
            <motion.div className="w-full md:w-1/2 sm:w-full order-1 md:order-2" 
                initial={{ opacity: 0, y: 50 }} 
                // animate={{ opacity: 1, y: 0 }} 
                whileInView={{ opacity: 1, y: 0 }} // animasi saat masuk viewport
                viewport={{ once: false, amount: 0.2 }} // jalan berulang, trigger saat 20% terlihat
                transition={{ duration: 1.0, ease: "easeOut" }}>
                <div className="gap-6">
                    <h3 className="text-5xl sm:text-5xl md:text-7xl font-extrabold bg-gradient-to-r from-blue-500 via-indigo-600 to-purple-700 text-center bg-clip-text text-transparent ">
                        Skills
                    </h3>
                    <div className="flex items-center justify-center mx-auto">
                        <div className="bg-white/30 ml-2 mr-2 p-8 shadow-lg rounded-lg xl:min-w-[500px] sm:min-w-[300px] max-w-lg min-w-lg min-h-auto  flex items-center justify-center">
                            {activeIndex !== null ? ( 
                                <div  key={activeIndex} className="p-4 transition-all duration-500 ease-in-out opacity-100 translate-y-4 animate-fadeInUp">
                                    <h1 className="text-xl text-center font-bold font-montserrat text-[#5381b8] transition-colors duration-900 ease-in-out">{skills[activeIndex].category}</h1>
                                    {skills[activeIndex].type.map((desc,idx)=>(
                                    <ul key={idx}>
                                            <li  className="list-[circle] ml-5 mt-1 text-gray-600 tracking-tight">
                                                <div className="flex flex-rows gap-4">
                                                    {/* <div className=""></div> */}
                                                    <img src={desc.icon} alt="icon" className="h-5 w-5" />
                                                    <label htmlFor="desc" className="font-montserrat xl:text-md md:text-sm sm:text-[12px]">
                                                        {desc.title}
                                                    </label>
                                                </div>
                                            </li>
                                    </ul>     
                                    ))}
                                </div>
                            ) : (
                                <div className="flex items-center justify-center">
                                <img src={"./img/skills-3.jpg"} className=" w-full md:h-96 sm:h-auto" alt="" />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </motion.div>
        </div>
     );
}
export default ListSkills;